import React from "react";

const UNIVERSES = [
    {
        emoji: "📱",
        title: "Télécoms & connectivité",
        sub: "Recharges mobiles, eSIM voyage, forfaits data — pour les réseaux avec une audience mobile.",
    },
    {
        emoji: "🎁",
        title: "Cadeaux & récompenses",
        sub: "Gift cards toutes enseignes, vouchers, cartes prépayées — pour les réseaux retail et RH.",
    },
    {
        emoji: "🎮",
        title: "Gaming & divertissement",
        sub: "Crédits jeux, abonnements, plateformes streaming — pour les audiences jeunes et loisirs.",
    },
    {
        emoji: "🌍",
        title: "Travel & mobilité",
        sub: "eSIM internationale, billetterie, transport — pour les réseaux voyage et hospitalité.",
    },
    {
        emoji: "⚡",
        title: "Services & utilities",
        sub: "Paiement de factures, services digitaux, top-up international — pour les réseaux communautaires et diaspora.",
    },
    {
        emoji: "🔧",
        title: "Et bien plus via ePaaS.io",
        sub: "Le catalogue s'étend en continu. Si ton réseau a une audience, il y a un produit pour elle.",
    },
];

const HERO_IMG =
    "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1200&q=80";

export default function Catalogue() {
    return (
        <section
            id="catalogue"
            className="relative py-24 sm:py-32 bg-cap-light overflow-hidden"
            data-testid="catalogue-section"
        >
            <div className="absolute inset-0 bg-grid-light opacity-80 pointer-events-none" />
            <div className="absolute -top-32 -left-32 w-[420px] h-[420px] rounded-full bg-cap-violet/10 blur-[120px]" />

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid lg:grid-cols-[1.1fr_1fr] gap-12 lg:gap-16 items-end">
                    <div className="max-w-2xl">
                        <p className="fade-up eyebrow">Le catalogue CapDistrib</p>
                        <h2
                            className="fade-up h-display text-3xl sm:text-4xl lg:text-[56px] font-bold mt-4 text-cap-ink"
                            style={{ animationDelay: "0.05s" }}
                            data-testid="catalogue-title"
                        >
                            Chaque réseau a son{" "}
                            <span className="text-cap-violet">
                                potentiel digital
                            </span>
                            .
                        </h2>
                        <p
                            className="fade-up mt-6 text-lg text-cap-textMuted leading-relaxed"
                            style={{ animationDelay: "0.1s" }}
                        >
                            Tout réseau qui accueille du public ou gère une
                            communauté peut distribuer des produits digitaux.
                            CapDistrib analyse le profil de chaque réseau et
                            construit le catalogue adapté à son audience.
                        </p>
                    </div>

                    <div
                        className="fade-up relative aspect-[5/4] rounded-3xl overflow-hidden ring-1 ring-cap-border shadow-xl"
                        style={{
                            animationDelay: "0.15s",
                            maskImage:
                                "linear-gradient(to right, transparent 0%, black 28%)",
                            WebkitMaskImage:
                                "linear-gradient(to right, transparent 0%, black 28%)",
                        }}
                    >
                        <img
                            src={HERO_IMG}
                            alt="Transaction digitale en boutique"
                            className="absolute inset-0 w-full h-full object-cover"
                        />
                        <div
                            className="absolute inset-0"
                            style={{
                                background:
                                    "linear-gradient(135deg, rgba(108,71,255,0.45) 0%, rgba(10,10,15,0.2) 60%)",
                            }}
                        />
                        <div className="absolute bottom-5 left-5 right-5 flex items-center gap-2">
                            <span className="glow-dot" />
                            <span className="text-white text-[12px] tracking-[0.2em] uppercase font-semibold">
                                Powered by ePaaS.io
                            </span>
                        </div>
                    </div>
                </div>

                <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {UNIVERSES.map((it, i) => (
                        <div
                            key={it.title}
                            className="fade-up glass-light p-7 flex items-start gap-5 group"
                            style={{ animationDelay: `${0.05 * i + 0.05}s` }}
                            data-testid={`catalogue-item-${i}`}
                        >
                            <div className="text-[40px] leading-none mt-0.5 transition-transform group-hover:scale-110 group-hover:rotate-3">
                                {it.emoji}
                            </div>
                            <div className="min-w-0">
                                <h3 className="h-display text-[17px] font-semibold text-cap-ink">
                                    {it.title}
                                </h3>
                                <p className="mt-1 text-[14.5px] text-cap-textMuted leading-relaxed">
                                    {it.sub}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

                <p
                    className="fade-up mt-12 text-center text-[15px] font-semibold text-cap-ink max-w-3xl mx-auto"
                    data-testid="catalogue-tagline"
                >
                    Pas de catalogue imposé.{" "}
                    <span className="text-cap-violet">
                        Un catalogue construit pour ton réseau.
                    </span>
                </p>
            </div>
        </section>
    );
}
